import { axiosInstance } from "api/services/axiosInstance";
import {
  PROJECT_URL,
  BOOKING_URL,
  MARKETPLACE_ORDER_URL,
} from "constants/ApiConstants";
import qs from "qs";

const projectApi = {
  createProject: (organizationId, payload) =>
    axiosInstance.put(`${PROJECT_URL}/${organizationId}`, payload),
  getProjectsList: (searchKeys, cancelToken) =>
    axiosInstance.get(`${BOOKING_URL}/ProjectsStatistics`, {
      params: { ...searchKeys },
      cancelToken,
    }),
  exportProjectsList: (searchKeys) => {
    const params = {
      ...searchKeys,
    };
    return axiosInstance.get(`CsvExport/ExportProjectsStatistics`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },
  getProjectSettingsAPI: (projectId, cancelToken) =>
    axiosInstance.get(`${PROJECT_URL}/${projectId}/GetProjectSettingsLookUps`, {
      cancelToken,
    }),
  getProjectStatisticsAPI: (projectId, cancelToken) =>
    axiosInstance.get(`${PROJECT_URL}/${projectId}/statistics/details`, {
      cancelToken,
    }),
  getPublicProjectStatisticsAPI: (projectId) =>
    axiosInstance.get(`${PROJECT_URL}/${projectId}/public/statistics`),
  getProjectDataAPI: (projectId, cancelToken) =>
    axiosInstance.get(`${PROJECT_URL}/${projectId}`, { cancelToken }),
  updateProject: (data) => axiosInstance.put(`${PROJECT_URL}`, data),
  getProjectBlocksAPI: (organizationId, projectId, cancelToken) =>
    axiosInstance.get(
      `org/${organizationId}/booking/project/${projectId}/map/blocks`,
      { cancelToken }
    ),
  getProjectStreetsAPI: (organizationId, projectId) =>
    axiosInstance.get(
      `org/${organizationId}/booking/project/${projectId}/map/streets`
    ),
  activateProject: (projectId) =>
    axiosInstance.put(`${PROJECT_URL}/${projectId}/activate`),
  deactivateProject: (projectId) =>
    axiosInstance.put(`${PROJECT_URL}/${projectId}/deactivate`),
  soldoutProject: (projectId) =>
    axiosInstance.put(`${PROJECT_URL}/${projectId}/soldout`),
  checkBlockAvailability: (blockNo) =>
    axiosInstance.get(`org/booking/isBlockAvailable/${blockNo}`),
  createProjectPartner: (data) =>
    axiosInstance.post(`${MARKETPLACE_ORDER_URL}/CreateProjectPartner`, data),
  getProjectPartnersById: (projectId, cancelToken) =>
    axiosInstance.get(
      `${MARKETPLACE_ORDER_URL}/GetPartnersByProjectId/${projectId}`,
      {
        cancelToken,
      }
    ),
  deleteProjectPartnersById: (partnerId) =>
    axiosInstance.delete(
      `${MARKETPLACE_ORDER_URL}/DeleteProjectPartner/${partnerId}`
    ),
  updateProjectPartner: (data) =>
    axiosInstance.put(`${MARKETPLACE_ORDER_URL}/UpdateProjectPartner`, data),
  getAllPartners: () =>
    axiosInstance.get(`${MARKETPLACE_ORDER_URL}/GetAllPartners`),
  getProjectWhitelistDevices: (entityType, entityId, cancelToken) => {
    return axiosInstance.get(
      `api/BackOffice/DevicesWhitelist/entityType/${entityType}/entityId/${entityId}`,
      {
        cancelToken,
      }
    );
  },
  addProjectWhitelistDevice: (data) => {
    return axiosInstance.post(`api/BackOffice/DevicesWhitelist`, data);
  },
  deleteProjectWhitelistDevice: (entityId, id) => {
    return axiosInstance.delete(
      `api/BackOffice/DevicesWhitelist/entity/${entityId}/deviceId/${id}`
    );
  },
  isProjectWhitelistDeviceEnabled: (entity, entityId, cancelToken) => {
    return axiosInstance.get(`api/BackOffice/DevicesWhitelist/isEnable`, {
      params: { entity, entityId },
      cancelToken,
    });
  },
  toggleProjectWhitelistDeviceEnabled: (data) => {
    return axiosInstance.put(`api/BackOffice/DevicesWhitelist/enable`, data);
  },
};

export default projectApi;
